import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollToRequest]',
})
export class CustomPopup3Directive {
  @Input('appScrollToRequest') set selectedRequestId(isSelected: boolean) {
    if (isSelected) {
      this.el.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }

  constructor(private readonly el: ElementRef) {}
}
